import {UyapRequest} from "./UyapRequest";

import {AdresRow, IHarcMasraf} from "./CommonInterfaces";

export interface DosyaHarcMasrafHesabiTalep {
    dosyaId: string,
    tcKimlikNo: number| string,
    dosyaTurKod: number//35
}

export interface DosyaHarcMasrafHesabiCevap {
    harcBilgileri: Array<IHarcMasraf>,
    toplam: number,
    taraflar: Array<TarafRow>
}

export interface TarafRow {
    kisiKurumBilgileriDVO: KisiKurumBilgileriDVO,
    dosyaKisiDVO: DosyaKisiDVO,
    vekilArrayList: Array<VekilArrayList>,
    secili: boolean,
    dogacakHakDahilmi: boolean,
    borcluBelediye: boolean,
    maasHesabiHaric: boolean,
    kisiMiKurumMu: number,
    guncelKisiKurumId: number,
    ilkKisiKurumId: number,
    tarafRolu: number,
    davaliDavaciGrup: string,
    aboneVarmi: boolean,
    tarafAdi: string
}

export interface KisiTumDVO {
    olumKaydi: boolean,
    isAvukat: boolean,
    isNoter: boolean,
    isTarafUyari: boolean,
    isHakimSavci: boolean,
    meslegi: string,
    okurYazarlik: string,
    vergiNo: string,
    ogrenimDurumu: string,
    meslekAciklamasi: string,
    ogrenimDurumuAciklamasi: string,
    ozurTuru: string,
    ozurOrani: number,
    ozurTuruAciklamasi: string,
    asker: string,
    harcDurumu: number,
    mernisDegisiklikVarmi: boolean,
    mernisDegisiklikNedeni: string,
    nufusaKayitIlKodu: number,
    nufusaKayitIlceKodu: number,
    mahKoy: string,
    ciltNo: string,
    aileSiraNo: string,
    siraNo: string,
    cuzdanSeriNo: string,
    cuzdanNo: string,
    kayitNo: string,
    verildigiTarih: string,
    verildigiIlKodu: number,
    verildigiIlceKodu: number,
    verilisNedeni: string,
    verildigiIlAdi: string,
    verildigiIlceAdi: string,
    uyrukAdi1: string,
    verilisNedeniAciklamasi: string,
    dinAciklamasi: string,
    sorguTuru: number,
    kisiKurumID: number,
    tcKimlikNo: string,
    adi: string,
    soyadi: string,
    babaAdi: string,
    anaAdi: string,
    dogumTarihiStr: string,
    uyrugu1: number,
    cinsiyeti: string,
    medeniHali: number,
    dini: string,
    dogumYeri: string,
    nufusaKayitliIlAdi: string,
    nufusaKayitliIlceAdi: string,
    aktifMernisAdresiSorgusu: boolean,
    mernisGuncellemesiYapildi: string,
    hasOlumKaydi: boolean
}

export interface KurumDVO {
    kisiKurumID: number;
    kurumAdi: string;
    vergiNo: string;
    harcDurumu: number;
    kamuOzel: string;
    veriGelisYeri: number;
    faaliyetDurumu: number;
    tacirMi: string;
    mersisIlKodu: number;
    mersisIlceKodu: number;
    digerIletisimBilgileri: any;
}

export interface KisiKurumBilgileriDVO {
    kisiTumDVO?: KisiTumDVO,
    kurumDVO?: KurumDVO,
    kisiKurumId: number,
    turu: number,
    ortakAd: string,
    adresList: Array<AdresRow>
}

export interface KisiBilgDVO {
    tcKimlikNo: string,
    adi: string,
    soyadi: string,
    babaAdi: string,
    anaAdi: string,
    dogumTarihiStr: string,
    dogumYeri: string,
    cinsiyeti: string,
    meslegi?: string,
    harcDurumu: number,
    ozurTuru: string,
    ogrenimDurumu?: string,
    ozurOrani: number,
    isEngelliKisiKurum: boolean
}

export interface KurumBilgDVO {
    isEngelliKisiKurum: boolean,
    kurumAdi: string,
    kurumVergiNo: string,
    harcDurumu?: number,
    kamuOzel: string
}

export interface DosyaBilg {
    dosyaDurumu: number,
    dosyaAcilisTarihi: string,
    birimId: string,
    dosyaTurKod: number
}

export interface DosyaKisiDVO {
    kisiBilgDVO: KisiBilgDVO,
    kurumBilgDVO: KurumBilgDVO,
    dosyaBilg: DosyaBilg,
    dosyasiIncelenebilir: boolean,
    kisiMiKurumMu: number,
    guncelKisiKurumId: number,
    ilkKisiKurumId: number,
    dosyaId: string,
    tarafRolu: number,
    dosyaKisiId: number,
    dosyaDurumuAktif: string,
    kimlikBilgisiAktif: string,
    kayitId: number,
    sanikStatusunde: string,
    davaliDavaciGrup: string,
    tarafDurumu: number,
    aboneVarmi: boolean,
    tarafAdi: string,
    tarafTC: string,
    cbsGroup: number,
}

export interface AvukatHesapBilg {
    hesapGenel: boolean,
    ibanNumarasi?: string
}

export interface AvukatDVO {
    AVUKAT_ID: number,
    GECERLILIK_AKTIF: string,
    KISI_KURUM_ID: number,
    MUVEKKIL_KISI_KURUM_ID: number,
    BAGLI_OLDUGU_BARO_KODU: number,
    BAGLI_OLDUGU_BARO_ADI: string,
    BARO_NO: number,
    TBB_NO: string,
    BAKANLIK_DOSYA_NO: number,
    TC_KIMLIK_NO: string,
    VEKIL_TIPI: string,
    ADI: string,
    SOYADI: string,
    vekilYetkiTuruDVOList: Array<any>,
    dosyaTarafVekilId: number,
    sifati: number,
    vekaletnameliMi: string,
    hazineAvukatiMi: boolean,
    kapanmaDurumuDegisiklikOldu: boolean,
    sertifikasiVar: boolean,
    yabanciAvukat: boolean,
    ortaklikMi: boolean,
    avukatlik_turu: string,
    tarafRolu: number,
    avukatHesapBilg: AvukatHesapBilg
}

export interface KisiTumBilgileriDVO {
    olumKaydi: boolean,
    isAvukat: boolean,
    isNoter: boolean,
    isTarafUyari: boolean,
    isHakimSavci: boolean,
    digerIletisimBilgileri: DigerIletisimBilgileri,
    mernisDegisiklikVarmi: boolean,
    mernisDegisiklikNedeni: string,
    sorguTuru: number,
    kisiKurumID: number,
    tcKimlikNo: string,
    adi: string,
    soyadi: string,
    aktifMernisAdresiSorgusu: boolean,
    hasOlumKaydi: boolean
}

export interface DigerIletisimBilgileri {
    ekleme: boolean,
    guncelleme: boolean,
    mode: number
}

export interface AdresList {
    adres: string,
    eTebligatAdresi: string,
    kisiKurumID: number,
    adresID: number,
    adresTuru: string,
    adresTuruAciklama: string,
    eklenebilirAdresMi: boolean,
    kayitliAdresMi: boolean,
    aktifAdresmi: boolean,
    guncellendiMi: boolean,
    aktif: string,
    gecerliAvukatlik: string
}

export interface DosyaKisiAdresDVO {
    gizliYazismaAdresi: boolean
}

export interface VekilArrayList {
    avukatDVO: AvukatDVO,
    kisiTumBilgileriDVO: KisiTumBilgileriDVO,
    adresList: Array<AdresList>,
    dosyaKisiAdresDVO: DosyaKisiAdresDVO,
    avukatinDosyasiVar: boolean,
    silinecekAvukat: boolean,
    atanacakAvukat: boolean,
    secili: boolean
}


export class DosyaHarcMasrafHesabi extends UyapRequest<DosyaHarcMasrafHesabiTalep, DosyaHarcMasrafHesabiCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Dosya harç masraf hesabı sorgulanıyor...";
    }


    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getMockResponse(): any {
        return [[{"harcmasrafKodStr":144134,"harcmasrafBedelmiOranmi":"B","harcMasrafBedel":427.6,"hesapMiktar":427.6,"ekranID":8,"pesinHarcDusulsunmu":"H","hmDurumu":0,"hmAktif":false,"isSatirDegisecek":false,"harcMasrafKod":12805,"harcMasrafAdi":"Başvurma Harcı","aciklama":"Takibe Başvurulurken Ödenen Harç Miktarı","baslangicHarci":"E","harcMasraf":"H","harcTip":0,"gv_tabi":0,"dv_tabi":0,"yg_tabi":0,"makbuzTipi":1},{"harcmasrafKodStr":14603,"harcmasrafBedelmiOranmi":"O","harcMasrafOran":0.5,"hesapMiktar":5,"ekranID":8,"pesinHarcDusulsunmu":"H","harcMasrafAltSiniri":0,"hmDurumu":0,"hmAktif":false,"isSatirDegisecek":false,"harcMasrafKod":12808,"harcMasrafAdi":"Peşin Harç","aciklama":"Takip Talebi Açılırken Alınır","baslangicHarci":"E","harcMasraf":"H","harcTip":2,"gv_tabi":0,"dv_tabi":0,"yg_tabi":0,"makbuzTipi":1},{"harcmasrafKodStr":144140,"harcmasrafBedelmiOranmi":"B","harcMasrafBedel":60.8,"hesapMiktar":60.8,"ekranID":8,"pesinHarcDusulsunmu":"H","hmDurumu":0,"hmAktif":false,"isSatirDegisecek":false,"harcMasrafKod":12809,"harcMasrafAdi":"Vekalet Suret Harcı","aciklama":"Vekaletname Suret Harcıdır","baslangicHarci":"E","harcMasraf":"H","harcTip":14,"gv_tabi":0,"dv_tabi":0,"yg_tabi":0,"makbuzTipi":1},{"hesapMiktar":96,"pesinHarcDusulsunmu":"H","hmDurumu":0,"hmAktif":false,"isSatirDegisecek":false,"harcMasrafAdi":"Vekalet Pulu","harcMasraf":"D","gv_tabi":0,"dv_tabi":0,"yg_tabi":0}],589.4,[{"kisiKurumBilgileriDVO":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"meslegi":"MESLK01624","okurYazarlik":"H","vergiNo":"25624973288","ogrenimDurumu":"OGREN00020","meslekAciklamasi":"tekniker","ogrenimDurumuAciklamasi":"Lise veya Dengi Meslek Okulu Mezunu","ozurTuru":"OZURT00005","ozurOrani":0,"ozurTuruAciklamasi":"Engelsiz","asker":"H","harcDurumu":1,"mernisDegisiklikVarmi":true,"mernisDegisiklikNedeni":"","nufusaKayitIlKodu":66,"nufusaKayitIlceKodu":3,"mahKoy":"KAZANKAYA","ciltNo":"68","aileSiraNo":"184","siraNo":"66","cuzdanSeriNo":"T13","cuzdanNo":"612547","kayitNo":"16143","verildigiTarih":"May 10, 2016 12:00:00 AM","verildigiIlKodu":6,"verildigiIlceKodu":18,"verilisNedeni":"NFSVN00006","verildigiIlAdi":"ANKARA","verildigiIlceAdi":"KEÇİÖREN","uyrukAdi1":"T.C.","verilisNedeniAciklamasi":"Değiştirme","dinAciklamasi":"Bilinmeyen","sorguTuru":0,"kisiKurumID":72835458,"tcKimlikNo":"25624973288","adi":"HÜSEYİN","soyadi":"TORUN","babaAdi":"DURAK","anaAdi":"DUDU","dogumTarihiStr":"26/07/1984","uyrugu1":1,"cinsiyeti":"E","medeniHali":0,"dini":"DINTR00009","dogumYeri":"ÇANKAYA","nufusaKayitliIlAdi":"YOZGAT","nufusaKayitliIlceAdi":"AYDINCIK","aktifMernisAdresiSorgusu":true,"mernisGuncellemesiYapildi":"H","hasOlumKaydi":false},"kisiKurumId":72835458,"turu":0,"ortakAd":"HÜSEYİN TORUN","adresList":[]},"dosyaKisiDVO":{"kisiBilgDVO":{"tcKimlikNo":"25624973288","adi":"HÜSEYİN","soyadi":"TORUN","babaAdi":"DURAK","anaAdi":"DUDU","dogumTarihiStr":"26/07/1984","dogumYeri":"ÇANKAYA","cinsiyeti":"E","meslegi":"MESLK01624","harcDurumu":1,"ozurTuru":"OZURT00005","ogrenimDurumu":"OGREN00020","ozurOrani":0,"isEngelliKisiKurum":false},"kurumBilgDVO":{"harcDurumu":1,"isEngelliKisiKurum":false},"dosyaBilg":{"dosyaDurumu":0,"dosyaAcilisTarihi":"May 4, 2024 10:23:57 AM","birimId":"1000954","dosyaTurKod":35},"dosyasiIncelenebilir":true,"kisiMiKurumMu":0,"guncelKisiKurumId":72835458,"ilkKisiKurumId":72835458,"dosyaId":"w@pUEPYro6bHLr+0THK8KSeMevyso7pKWhdVgMNHi04A8WaVXLC@aybJkiMjL9s7","tarafRolu":21,"dosyaKisiId":1422247958,"dosyaDurumuAktif":"E","kimlikBilgisiAktif":"E","kayitId":13225094938,"sanikStatusunde":"H","davaliDavaciGrup":"N","tarafDurumu":0,"aboneVarmi":true,"tarafAdi":"HÜSEYİN TORUN","tarafTC":"25624973288","cbsGroup":3},"vekilArrayList":[{"avukatDVO":{"AVUKAT_ID":42231,"GECERLILIK_AKTIF":"E","KISI_KURUM_ID":4000023833,"MUVEKKIL_KISI_KURUM_ID":72835458,"BAGLI_OLDUGU_BARO_KODU":6,"BAGLI_OLDUGU_BARO_ADI":"ANKARA","BARO_NO":11997,"TBB_NO":"35922","BAKANLIK_DOSYA_NO":0,"TC_KIMLIK_NO":"32413434868","VEKIL_TIPI":"B","ADI":"HÜSEYİN GÜLTEKİN","SOYADI":"DURĞUN","vekilYetkiTuruDVOList":[],"dosyaTarafVekilId":484060525,"sifati":0,"vekaletnameliMi":"E","hazineAvukatiMi":false,"kapanmaDurumuDegisiklikOldu":false,"sertifikasiVar":false,"yabanciAvukat":false,"ortaklikMi":false,"avukatlik_turu":"H","tarafRolu":21,"avukatHesapBilg":{"hesapGenel":true}},"kisiTumBilgileriDVO":{"olumKaydi":false,"isAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"digerIletisimBilgileri":{"ekleme":false,"guncelleme":false,"mode":2},"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","sorguTuru":0,"kisiKurumID":4000023833,"tcKimlikNo":"32413434868","adi":"HÜSEYİN GÜLTEKİN","soyadi":"DURĞUN","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"adresList":[{"adres":" ","eTebligatAdresi":"16586-85761-56536","kisiKurumID":4000023833,"adresID":238315398,"adresTuru":"ADRTR00015","adresTuruAciklama":"Avukatlık Elektronik Tebligat Adresi","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false,"aktif":"E","gecerliAvukatlik":"E"}],"dosyaKisiAdresDVO":{"gizliYazismaAdresi":false},"avukatinDosyasiVar":true,"silinecekAvukat":false,"atanacakAvukat":false,"secili":false}],"secili":false,"dogacakHakDahilmi":false,"borcluBelediye":false,"maasHesabiHaric":false,"kisiMiKurumMu":0,"guncelKisiKurumId":72835458,"ilkKisiKurumId":72835458,"tarafRolu":21,"davaliDavaciGrup":"N","aboneVarmi":true,"tarafAdi":"HÜSEYİN TORUN"},{"kisiKurumBilgileriDVO":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"okurYazarlik":"H","vergiNo":"43465031264","ozurTuru":"OZURT00005","ozurTuruAciklamasi":"Engelsiz","asker":"H","harcDurumu":1,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","nufusaKayitIlKodu":21,"nufusaKayitIlceKodu":17,"mahKoy":"DOĞANLI","ciltNo":"61","aileSiraNo":"36","siraNo":"67","cuzdanSeriNo":"A30P06000","kayitNo":"4973","verildigiTarih":"Apr 16, 2015 9:13:43 AM","verildigiIlKodu":99,"verildigiIlceKodu":0,"verilisNedeni":"NFSVN00006","verildigiIlAdi":"SİLİNMİŞ","verildigiIlceAdi":"SİLİNMİŞ","uyrukAdi1":"T.C.","verilisNedeniAciklamasi":"Değiştirme","dinAciklamasi":"Bilinmeyen","sorguTuru":0,"kisiKurumID":197008721,"tcKimlikNo":"43465031264","adi":"MUHAMMED VEYSİ","soyadi":"IŞIK","babaAdi":"HASAN","anaAdi":"ELİFHAN","dogumTarihiStr":"25/05/1997","uyrugu1":1,"cinsiyeti":"E","medeniHali":0,"dini":"DINTR00009","dogumYeri":"DİYARBAKIR","nufusaKayitliIlAdi":"DİYARBAKIR","nufusaKayitliIlceAdi":"SUR","aktifMernisAdresiSorgusu":true,"mernisGuncellemesiYapildi":"E","hasOlumKaydi":false},"kisiKurumId":197008721,"turu":0,"ortakAd":"MUHAMMED VEYSİ IŞIK","adresList":[]},"dosyaKisiDVO":{"kisiBilgDVO":{"tcKimlikNo":"43465031264","adi":"MUHAMMED VEYSİ","soyadi":"IŞIK","babaAdi":"HASAN","anaAdi":"ELİFHAN","dogumTarihiStr":"25/05/1997","dogumYeri":"DİYARBAKIR","cinsiyeti":"E","harcDurumu":1,"ozurTuru":"OZURT00005","ozurOrani":0,"isEngelliKisiKurum":false},"kurumBilgDVO":{"harcDurumu":1,"isEngelliKisiKurum":false},"dosyaBilg":{"dosyaDurumu":0,"dosyaAcilisTarihi":"May 4, 2024 10:23:57 AM","birimId":"1000954","dosyaTurKod":35},"dosyasiIncelenebilir":true,"kisiMiKurumMu":0,"guncelKisiKurumId":197008721,"ilkKisiKurumId":197008721,"dosyaId":"w@pUEPYro6bHLr+0THK8KSeMevyso7pKWhdVgMNHi04A8WaVXLC@aybJkiMjL9s7","tarafRolu":22,"dosyaKisiId":1422247959,"dosyaDurumuAktif":"E","kimlikBilgisiAktif":"E","kayitId":13225094940,"sanikStatusunde":"E","davaliDavaciGrup":"L","tarafDurumu":0,"aboneVarmi":true,"tarafAdi":"MUHAMMED VEYSİ IŞIK","tarafTC":"43465031264","cbsGroup":3},"vekilArrayList":[],"secili":false,"dogacakHakDahilmi":false,"borcluBelediye":false,"maasHesabiHaric":false,"kisiMiKurumMu":0,"guncelKisiKurumId":197008721,"ilkKisiKurumId":197008721,"tarafRolu":22,"davaliDavaciGrup":"L","aboneVarmi":true,"tarafAdi":"MUHAMMED VEYSİ IŞIK"}]];
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'dosya_harc_masraf_hesabi.ajx';
    }

    async parse(data: Array<any>): Promise<DosyaHarcMasrafHesabiCevap> {
        return {harcBilgileri: data[0], toplam: data[1], taraflar: data[2]};
    }
}

export default DosyaHarcMasrafHesabi;
